import React, { useEffect, useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileDownload, faFileSignature, faUsers } from "@fortawesome/free-solid-svg-icons";
import DatePicker from "react-datepicker";
import moment from "moment";
import { toast } from "react-toastify";
import { StylesDatePicker } from "../../../ui/stylesDatePicker";
import { ModalButton } from "../../../ui/buttons";
import { ContentKpi, IconKpi, KPIcard } from "../../../ui/kpis";
import { CustomLabel } from "../../../ui/labels";
import { configDatePickerLenguage } from "../../../components/RelevosInfoGeneral/utils";
import { importRelevamientosCN, subclientsKpis } from "../../../services/subclientesServices";
import useFetcher from "../../../hooks/useFetcher";
import { BlurSpinner } from "../../../components/BlurSpinner";

const RelevamientoCNModal = ({ toggle, isOpen }) => {
  const unMesAtras = moment().subtract(30, "days").format("DD/MM/YYYY");
  const fechaActual = moment().format("DD/MM/YYYY");
  const locale = configDatePickerLenguage();
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  const [params, setParams] = useState([{ startDate: moment().subtract(30, "days").format("YYYY-MM-DD"), endDate: moment().format("YYYY-MM-DD") }]);
  const [kpis, isLoadingKpis] = useFetcher(subclientsKpis, params);
  const [exportRelevoCN, setExportRelevoCN] = useState(false);

  // funcion para exportar
  const handleExportar = async () => {
    if (startDate && endDate) {
      setExportRelevoCN(true);
      toast.success("Exportando archivo...");
      await importRelevamientosCN(params);
      setExportRelevoCN(false);
    }
    toggle();
  };

  // actualiza el rango de fechas con los ultimos 30 dias
  useEffect(() => {
    setDateRange([moment(unMesAtras, "DD/MM/YYYY").toDate(), moment(fechaActual, "DD/MM/YYYY").toDate()]);
  }, []);

  // formatea la fecha para los params
  useEffect(() => {
    if (startDate && endDate) {
      const start = moment(startDate).format("YYYY-MM-DD");
      const end = moment(endDate).format("YYYY-MM-DD");
      setParams([{ startDate: start, endDate: end }]);
    }
  }, [startDate, endDate]);

  // formatea el valor del rango de fechas
  const getDataRangeValue = (inputStartDate, inputEndDate) => {
    const start = inputStartDate ? moment(inputStartDate).format("DD/MM/YYYY") : "";
    const end = inputEndDate ? moment(inputEndDate).format("DD/MM/YYYY") : "";
    return `${start} - ${end}`;
  };

  return (
    <div style={{ fontFamily: "Nunito" }}>
      <Modal isOpen={isOpen} centered style={{ maxWidth: "450px", width: "50%" }}>
        <ModalHeader className="border-0 height-50" toggle={toggle} style={{ backgroundColor: "#f8f8f8", borderRadius: "8px" }} />
        <ModalBody style={{ backgroundColor: "#f8f8f8", borderRadius: "8px" }}>
          <>
            <FontAwesomeIcon icon={faFileDownload} color="#293134" size="3x" className="mb-2" />
            <div className="col-md-12">
              <StylesDatePicker className="mb-3 w-100">
                <CustomLabel htmlFor="fechaTC"> Rango de fechas </CustomLabel>
                <DatePicker
                  locale={locale}
                  id="fecha"
                  className="digits date-input"
                  selectsRange
                  startDate={startDate}
                  endDate={endDate}
                  onChange={(update) => {
                    setDateRange(update);
                  }}
                  value={getDataRangeValue(startDate, endDate)}
                />
              </StylesDatePicker>
            </div>
            <div className="col-md-12">
              <BlurSpinner isLoading={isLoadingKpis}>
                <KPIcard className="card">
                  <div className="card-body d-flex align-items-center justify-content-between mb-2 pb-0">
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                      <IconKpi>
                        <FontAwesomeIcon icon={faFileSignature} width="50px" height="50px" />
                      </IconKpi>
                      <ContentKpi>
                        <h3>Relevos</h3>
                        <div className="d-flex align-items-end justify-content-start">
                          {kpis ? (
                            <>
                              <p>{kpis.relevos}</p>
                            </>
                          ) : (
                            <p>-</p>
                          )}
                        </div>
                      </ContentKpi>
                    </div>
                  </div>
                  <div className="card-body d-flex align-items-center justify-content-between mb-2 pb-0">
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                      <IconKpi>
                        <FontAwesomeIcon icon={faUsers} width="50px" height="50px" />
                      </IconKpi>
                      <ContentKpi>
                        <h3>Nuevos clientes</h3>
                        <div className="d-flex align-items-end justify-content-start">
                          {kpis ? (
                            <>
                              <p>{kpis.subclientes}</p>
                            </>
                          ) : (
                            <p>-</p>
                          )}
                        </div>
                      </ContentKpi>
                    </div>
                  </div>
                </KPIcard>
              </BlurSpinner>
            </div>
          </>
          <ModalFooter className="border-0 w-100">
            <div className="d-flex justify-content-end">
              <ModalButton className="btn px-2 py-1 text-center mr-2" onClick={toggle} type="button">
                Cerrar
              </ModalButton>
              <ModalButton
                className="btn px-2 py-1 text-center"
                style={{ backgroundColor: "#F0292A", color: "white" }}
                onClick={() => {
                  handleExportar();
                }}
                type="button"
                disabled={exportRelevoCN}
              >
                Exportar
              </ModalButton>
            </div>
          </ModalFooter>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default RelevamientoCNModal;
